import { render, staticRenderFns } from "./OnboardingEmployees.vue?vue&type=template&id=1f4fd502&"
import script from "./OnboardingEmployees.vue?vue&type=script&lang=js&"
export * from "./OnboardingEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports